import { ConfirmResendReturnLabelSchema } from "@redotech/redo-agents-cards/support-agents/confirm-resend-return-label";
import * as z from "zod";
import { literal, object, string } from "zod";
import { ContentType } from "../../conversation";
import {
  AutoGeneratedFieldsSchema,
  BaseToolCallMessageSchema,
} from "../message-parser-utils";
export const ResendReturnLabelCustomerInputContentSchema = object({
  orderEmail: string(),
  orderId: string(),
});

export type ResendReturnLabelCustomerInputContent = z.infer<
  typeof ResendReturnLabelCustomerInputContentSchema
>;

/**
 * Message type for when ai wants to let the customer request a return
 * shipping label to be resent.
 */
const ResendReturnLabelMessageSchema = BaseToolCallMessageSchema.extend({
  contentType: literal(ContentType.RESEND_RETURN_LABEL_UI),
  structuredContent: ConfirmResendReturnLabelSchema,
  customerInputContent: ResendReturnLabelCustomerInputContentSchema.optional(),
});

export type ResendReturnLabelMessageType = z.infer<
  typeof ResendReturnLabelMessageSchema
>;

export const ResendReturnLabelMessageDbParser =
  ResendReturnLabelMessageSchema.merge(AutoGeneratedFieldsSchema);
